import React from "react";
import ReactDOM from "react-dom";
// import { useNavigate } from "react-router-dom";
import "./notifier.scss";

const Notifier = (props) => {
	/* const navigate = useNavigate();
	useEffect(() => {
		setTimeout(() => {
			navigate('/');
		}, 5000);
	}) */
	return ReactDOM.createPortal(
		<>
			{/* <div className="popboxbody">
				<div className="popbox-content">
					<h1>Popbox</h1>
					<h3>{props.boxobj.msg}</h3>
					<p>You will be transform to home page in 5 seconds</p>
					<p>This is simple portal created with ReactDOM.createPortal()</p>
				</div>
			</div> */}
			<div className="notifier-toast">
				<h4>Alert !</h4>
				<p>{props.boxobj.msg}</p>
			</div>
		</>,
		document.getElementById("helpnotifier")
	);
};

export default Notifier;
